class GraphQLError extends Error {
  constructor(errorDetails) {
    super(errorDetails.message);
    this.name = 'GraphQLError';

    this.errorMessages = errorDetails.errorMessages;
    this.request = errorDetails.request;
    this.message = `We're having some trouble connecting. You might try reloading the page or checking your internet connection. ${errorDetails.message}`;
  }

  // Preserve backwards compatibility with legacy redux-framework code that relies on this static method existing,
  // such as the `ErrorModal` and `ErrorSummary` components.
  static summary(errorInstance) {
    return errorInstance.message;
  }
}

export default GraphQLError;
